// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MiniChatHeader_root__a6pYS {
  border-bottom: 1px solid #E2E2E2;
  display: flex;
  justify-content: space-between;
  align-items: stretch;
}

.MiniChatHeader_content__6ugNC {
  padding: 8px 16px;
  flex-grow: 1;
  display: flex;
  max-width: 100%;
  min-width: 1px;
}
.MiniChatHeader_content__info__wpnq4 {
  display: flex;
  justify-content: center;
  align-items: stretch;
  flex-direction: column;
  min-width: 1px;
}

.MiniChatHeader_actions__4\\+vFk {
  display: inline-flex;
  align-items: stretch;
}

.MiniChatHeader_avatar__BSv-9 {
  margin-right: 16px;
  flex-shrink: 0;
  position: relative;
  display: inline-block;
  cursor: pointer;
}

.MiniChatHeader_name__aoACC {
  text-decoration: none;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  color: #272A36;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.MiniChatHeader_name__container__7xCk2 {
  display: flex;
  align-items: center;
  max-width: 100%;
  min-width: 1px;
  margin-bottom: 2px;
}
.MiniChatHeader_nameDialog__linDj {
  transition: 0.3s color;
}
.MiniChatHeader_nameDialog__linDj:hover {
  cursor: pointer;
  color: #2c5bcc;
}

.MiniChatHeader_status__lbjSs {
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #8E8E93;
  max-width: 100%;
  min-width: 1px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.MiniChatHeader_closeButton__QjnQq {
  width: 56px;
  height: 100%;
  background: transparent;
  border: 0;
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  align-items: center;
}
.MiniChatHeader_closeButton__icon__9kisL {
  transition: 0.2s all;
  transform: rotate(0deg);
}
.MiniChatHeader_closeButton__icon__9kisL path {
  transition: 0.2s all;
  fill: #8E8E93 !important;
}
.MiniChatHeader_closeButton__QjnQq:hover .MiniChatHeader_closeButton__icon__9kisL {
  transform: rotate(180deg);
}
.MiniChatHeader_closeButton__QjnQq:hover .MiniChatHeader_closeButton__icon__9kisL path {
  fill: black !important;
}

.MiniChatHeader_moreActionsButton__ObHZv {
  display: inline-flex;
  justify-content: flex-end;
  align-items: center;
  width: 32px;
  height: 100%;
  background: transparent;
  border: 0;
  cursor: pointer;
}

.MiniChatHeader_expandButton__3xztc {
  display: inline-flex;
  justify-content: flex-end;
  align-items: center;
  width: 32px;
  height: 100%;
  background: transparent;
  border: 0;
  cursor: pointer;
}
.MiniChatHeader_expandButton__3xztc svg, .MiniChatHeader_expandButton__3xztc svg path {
  transition: 0.2s all;
}
.MiniChatHeader_expandButton__3xztc:not(.MiniChatHeader_enabled__GEBG3):hover svg {
  animation: 1.5s MiniChatHeader_Expand__Ab9qg infinite;
}
.MiniChatHeader_expandButton__3xztc:not(.MiniChatHeader_enabled__GEBG3):hover svg path {
  fill: black;
}
.MiniChatHeader_expandButton__3xztc.MiniChatHeader_enabled__GEBG3:hover svg {
  animation: 1.5s MiniChatHeader_Unexpand__0KGZK infinite;
}
.MiniChatHeader_expandButton__3xztc.MiniChatHeader_enabled__GEBG3:hover svg path {
  fill: black;
}

@keyframes MiniChatHeader_Expand__Ab9qg {
  0% {
    transform: scale(0.5);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1.1);
  }
}
@keyframes MiniChatHeader_Unexpand__0KGZK {
  0% {
    transform: scale(1.3);
  }
  70% {
    transform: scale(0.9);
  }
  100% {
    transform: scale(0.9);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/chats/MiniChat/MiniChatHeader/MiniChatHeader.module.scss","webpack://./src/assets/scss/mixins.scss"],"names":[],"mappings":"AAEA;EACE,gCAAA;EACA,aAAA;EACA,8BAAA;EACA,oBAAA;AADF;;AAKA;EACE,iBAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,cAAA;AAFF;AAIE;EACE,aAAA;EACA,uBAAA;EACA,oBAAA;EACA,sBAAA;EACA,cAAA;AAFJ;;AAMA;EACE,oBAAA;EACA,oBAAA;AAHF;;AAMA;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,qBAAA;EACA,eAAA;AAHF;;AAMA;EACE,qBAAA;EAWA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;ECtDA,mBAAA;EACA,gBAAA;EACA,uBAAA;AD0CF;AAHE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;EAEA,kBAAA;AAIJ;AAKE;EACE,sBAAA;AAHJ;AAKI;EACE,eAAA;EACA,cAAA;AAHN;;AAWA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EC3EA,mBAAA;EACA,gBAAA;EACA,uBAAA;ADoEF;;AAUA;EACE,WAAA;EACA,YAAA;EAEA,uBAAA;EACA,SAAA;EACA,eAAA;EAEA,oBAAA;EACA,uBAAA;EACA,mBAAA;AATF;AAWE;EACE,oBAAA;EACA,uBAAA;AATJ;AAWI;EACE,oBAAA;EACA,wBAAA;AATN;AAaE;EACE,yBAAA;AAXJ;AAaI;EACE,sBAAA;AAXN;;AAgBA;EACE,oBAAA;EACA,yBAAA;EACA,mBAAA;EAEA,WAAA;EACA,YAAA;EAEA,uBAAA;EACA,SAAA;EACA,eAAA;AAfF;;AAkBA;EACE,oBAAA;EACA,yBAAA;EACA,mBAAA;EAEA,WAAA;EACA,YAAA;EAEA,uBAAA;EACA,SAAA;EACA,eAAA;AAjBF;AAmBE;EACE,oBAAA;AAjBJ;AAoBE;EACE,qDAAA;AAlBJ;AAoBI;EACE,WAAA;AAlBN;AAqBE;EACE,uDAAA;AAnBJ;AAqBI;EACE,WAAA;AAnBN;;AAwBA;EACE;IACE,qBAAA;EArBF;EAuBA;IACE,qBAAA;EArBF;EAuBA;IACE,qBAAA;EArBF;AACF;AAwBA;EACE;IACE,qBAAA;EAtBF;EAwBA;IACE,qBAAA;EAtBF;EAwBA;IACE,qBAAA;EAtBF;AACF","sourcesContent":["@import '@/assets/scss/mixins.scss';\n\n.root {\n  border-bottom: 1px solid #E2E2E2;\n  display: flex;\n  justify-content: space-between;\n  align-items: stretch;\n}\n\n\n.content {\n  padding: 8px 16px;\n  flex-grow: 1;\n  display: flex;\n  max-width: 100%;\n  min-width: 1px;\n\n  &__info {\n    display: flex;\n    justify-content: center;\n    align-items: stretch;\n    flex-direction: column;\n    min-width: 1px;\n  }\n}\n\n.actions {\n  display: inline-flex;\n  align-items: stretch;\n}\n\n.avatar {\n  margin-right: 16px;\n  flex-shrink: 0;\n  position: relative;\n  display: inline-block;\n  cursor: pointer;\n}\n\n.name {\n  text-decoration: none;\n\n  &__container {\n    display: flex;\n    align-items: center;\n    max-width: 100%;\n    min-width: 1px;\n\n    margin-bottom: 2px;\n  }\n\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 16px;\n  color: #272A36;\n  max-width: 100%;\n\n  &Dialog {\n    transition: 0.3s color;\n\n    &:hover {\n      cursor: pointer;\n      color: #2c5bcc;\n    }\n  }\n\n\n  @include ellipsis;\n}\n\n.status {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 16px;\n  color: #8E8E93;\n  max-width: 100%;\n  min-width: 1px;\n\n  @include ellipsis;\n}\n\n.closeButton {\n  width: 56px;\n  height: 100%;\n\n  background: transparent;\n  border: 0;\n  cursor: pointer;\n\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n\n  &__icon {\n    transition: 0.2s all;\n    transform: rotate(0deg);\n\n    path {\n      transition: 0.2s all;\n      fill: #8E8E93 !important;\n    }\n  }\n\n  &:hover .closeButton__icon {\n    transform: rotate(180deg);\n\n    path {\n      fill: black !important;\n    }\n  }\n}\n\n.moreActionsButton {\n  display: inline-flex;\n  justify-content: flex-end;\n  align-items: center;\n\n  width: 32px;\n  height: 100%;\n\n  background: transparent;\n  border: 0;\n  cursor: pointer;\n}\n\n.expandButton {\n  display: inline-flex;\n  justify-content: flex-end;\n  align-items: center;\n\n  width: 32px;\n  height: 100%;\n\n  background: transparent;\n  border: 0;\n  cursor: pointer;\n\n  svg, svg path {\n    transition: 0.2s all;\n  }\n\n  &:not(.enabled):hover svg {\n    animation: 1.5s Expand infinite;\n\n    & path {\n      fill: black;\n    }\n  }\n  &.enabled:hover svg {\n    animation: 1.5s Unexpand infinite;\n\n    & path {\n      fill: black;\n    }\n  }\n}\n\n@keyframes Expand {\n  0% {\n    transform: scale(0.5);\n  }\n  50% {\n    transform: scale(1.1);\n  }\n  100% {\n    transform: scale(1.1);\n  }\n}\n\n@keyframes Unexpand {\n  0% {\n    transform: scale(1.3);\n  }\n  70% {\n    transform: scale(0.9);\n  }\n  100% {\n    transform: scale(0.9);\n  }\n}\n","@mixin ellipsis {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n@mixin invisible-scroll {\n  overflow: -moz-scrollbars-none;\n  overflow: -moz-hidden-unscrollable;\n  scrollbar-width: none;\n\n  &::-webkit-scrollbar {\n    display: none;\n    width: 0 !important;\n    -ms-overflow-style: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `MiniChatHeader_root__a6pYS`,
	"content": `MiniChatHeader_content__6ugNC`,
	"content__info": `MiniChatHeader_content__info__wpnq4`,
	"actions": `MiniChatHeader_actions__4+vFk`,
	"avatar": `MiniChatHeader_avatar__BSv-9`,
	"name": `MiniChatHeader_name__aoACC`,
	"name__container": `MiniChatHeader_name__container__7xCk2`,
	"nameDialog": `MiniChatHeader_nameDialog__linDj`,
	"status": `MiniChatHeader_status__lbjSs`,
	"closeButton": `MiniChatHeader_closeButton__QjnQq`,
	"closeButton__icon": `MiniChatHeader_closeButton__icon__9kisL`,
	"moreActionsButton": `MiniChatHeader_moreActionsButton__ObHZv`,
	"expandButton": `MiniChatHeader_expandButton__3xztc`,
	"enabled": `MiniChatHeader_enabled__GEBG3`,
	"Expand": `MiniChatHeader_Expand__Ab9qg`,
	"Unexpand": `MiniChatHeader_Unexpand__0KGZK`
};
export default ___CSS_LOADER_EXPORT___;
